module.exports = __webpack_public_path__ + "static/media/PayPal_logo.1f1b057a.svg";